<template>
  <section class="match-hero-banner" :class="{ 'has-nav-panel': showNavPanel, 'hide-mobile-hero': hideMobileHero }">
    <div v-if="showOverlay" class="hero-overlay"></div>

    <div class="hero-shell">
      <picture>
        <source v-if="mobileHeroImage" media="(max-width: 750px)" :srcset="mobileHeroImage" />
        <img class="hero-image" :src="heroImage" :alt="alt" />
      </picture>
      <template v-if="showHomeButton">
        <MatchBackHomeButton :image="homeButtonImage" />
      </template>
      <div v-if="showNavPanel" ref="navStickyTrigger" class="nav-sticky-trigger"></div>

      <div v-if="showNavPanel" class="nav-panel" :class="{ 'is-sticky': isNavSticky }">
        <div class="nav-bg" :style="navBgStyle">
          <slot name="nav"></slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MatchBackHomeButton from '@/components/match/common/MatchBackHomeButton.vue'
import { getImg } from '@/utils/matchAsset'

export default {
  name: 'MatchHeroBanner',
  components: { MatchBackHomeButton },
  props: {
    heroImage: { type: String, required: true },
    mobileHeroImage: { type: String, default: '' },
    alt: { type: String, default: '' },
    navBg: { type: String, default: '' },
    showNavPanel: { type: Boolean, default: false },
    showOverlay: { type: Boolean, default: true },
    showHomeButton: { type: Boolean, default: true },
    hideMobileHero: { type: Boolean, default: false },
    homeButtonImage: {
      type: String,
      default: () => getImg('match/pc/match/back-home-button.png'),
    },
  },
  data() {
    return { isNavSticky: false }
  },
  computed: {
    navBgStyle() {
      return this.navBg ? { backgroundImage: `url(${this.navBg})` } : {}
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateNavStickyState, { passive: true })
    this.updateNavStickyState()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateNavStickyState)
  },
  methods: {
    updateNavStickyState() {
      if (!this.showNavPanel || !this.$refs.navStickyTrigger) return
      this.isNavSticky = this.$refs.navStickyTrigger.getBoundingClientRect().top <= 0
    },
  },
}
</script>

<style scoped lang="scss">
.match-hero-banner {
  position: relative;
  width: 100%;
  min-height: 5.625rem;
  background-color: #0e1016;
  overflow: hidden;

  .hero-overlay {
    display: none;
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.16) 100%);
    pointer-events: none;
    z-index: 1;
  }

  .hero-shell {
    position: relative;
    width: 100%;
    min-height: 5.625rem;
    margin: 0 auto;
  }

  .hero-image {
    display: block;
    width: 100%;
    min-height: 5.625rem;
    
    object-fit: cover;
    object-position: center top;
  }

  picture {
    display: block;
  }

  .nav-panel {
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 7.8125rem;
    height: 1.322917rem;
    transform: translateX(-50%);
    z-index: 2;

    &.is-sticky {
      position: fixed;
      top: 0;
      bottom: auto;
      z-index: 10;
    }
  }

  .nav-sticky-trigger {
    position: absolute;
    right: 0;
    bottom: 1.322917rem;
    left: 0;
    height: 0.005208rem;
    pointer-events: none;
  }

  .nav-bg {
    position: relative;
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media (max-width: 750px) {
    &.hide-mobile-hero {
      background-color: transparent;
      height: 15.146rem;
      picture {
        display: none;
      }
    }
    .hero-shell{
      height: 14.746rem;
       .nav-panel {
      transform: translateX(-50%) scale(1.29);
      transform-origin: center bottom;
      left: 50%;
      .nav-label-en{
        display: none;
      }
    }
    }
   

    .nav-sticky-trigger {
      bottom: 1.535rem;
    }
  }
}
</style>
